import { api } from '../axios'
import type { ApiResponse, Religion } from '../../../types'

export const religionsApi = {
  getAll: () =>
    api.get<ApiResponse<Religion[]>>('/religions'),

  getActive: () =>
    api.get<ApiResponse<Religion[]>>('/religions/active'),

  getById: (id: number) =>
    api.get<ApiResponse<Religion>>(`/religions/${id}`),

  create: (data: Religion) =>
    api.post<ApiResponse<Religion>>('/religions', data),

  update: (id: number, data: Partial<Religion>) =>
    api.put<ApiResponse<Religion>>(`/religions/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/religions/${id}`),
  
  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/religions/${id}/permanent`),
  
  forceDelete: (id: number) =>
    api.delete<ApiResponse>(`/religions/${id}/force`),
}

